import React from 'react';
import { Creator } from './creator/Creator';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import { creatorActions } from '@/store/slices/creatorSlice';
import { MessageDataTitle } from '@/types/types';
import { Flex, Modal, Text, Image } from '@mantine/core';
import { useContent } from '@/providers/ContentProvider';
import Logo from '@/assets/images/logo.png';
import styles from './App.module.scss';

const url = new URL(window.location.href);
const searchParams = new URLSearchParams(url.search);
const baseSlug = 'creator.';

export const isDev = !!searchParams.get('DEV') || import.meta.env.DEV;

const App: React.FC = () => {
	const dispatch = useTypedDispatch();
	const { getContent } = useContent();

	const { options } = useTypedSelector((app) => app.creator);

	const modalControls = {
		open: () => {
			dispatch(creatorActions.updateOptions({ isOpen: true }));
		},
		close: () => {
			dispatch(creatorActions.updateOptions({ isOpen: false }));
		},
	};

	return (
		<Modal
			fullScreen
			opened={options.isOpen}
			title={
				<Flex
					align="center"
					justify="space-between"
					direction={{
						base: 'column',
						md: 'row',
					}}
				>
					<Text className="creator-title" size="xl" fw="bold">
						{getContent(`${baseSlug}title`)}
					</Text>
					<Image src={Logo} w={200} />
				</Flex>
			}
			onClose={modalControls.close}
			transitionProps={{
				duration: 250,
				transition: 'fade',
				onExited: () => {
					window!.top!.postMessage(
						{
							title: MessageDataTitle.TOGGLE,
							isOpen: false,
						},
						'*'
					);
				},
			}}
			classNames={{
				title: styles.modalTitle,
				header: styles.modalHeader,
				content: styles.modalContent,
				body: styles.modalBody,
			}}
		>
			<Creator />
		</Modal>
	);
};

export default App;
